import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router } from "@angular/router";
import { Observable } from "rxjs";
import { map, tap } from "rxjs/operators";
import { AuthService } from "@auth0/auth0-angular";
import { localStorageKey } from "@core/constants";

@Injectable()
export class PermissionGuard {
  constructor(protected router: Router, public auth: AuthService) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.auth.isAuthenticated$.pipe(
      tap((isAuthenticated) => {
        const userData =
          localStorage.getItem(localStorageKey) &&
          JSON.parse(localStorage.getItem(localStorageKey))?.user;

        const permissionsAllowed = route?.data?.roles as string[];

        const userHasPermisson =
          !route?.data?.roles?.length ||
          !!permissionsAllowed.find((p) => {
            return userData?.permissions?.includes(p);
          });
        const canAccess = isAuthenticated && userHasPermisson;
        if (!canAccess) {
          this.router.navigate(["/dashboard/home"]);
        }
        return canAccess;
      }),
      map((hasPermissions) => hasPermissions)
    );
  }
}
